var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { StatusBar } from 'expo-status-bar';
import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import { useNavigationContainerRef } from '../../Hooks/UseNavigatorRef';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { SafeAreaProviderView, getHasSafeAreaProvider } from './SafeAreaProviderView';
import { ActionSheetProviderView, getHasActionSheetProvider } from './ActionSheetProviderView';
import { updateOffset } from '../../Hooks/UseOrientation';
import { useColorScheme } from '../../Hooks/UseColorScheme';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { useDirection } from '../../Hooks/UseDirection';
const linking = {
    prefixes: [],
};
export const NavigationWrapperView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.navigationWrapper
})((_a) => {
    var { safeAreaProps } = _a, props = __rest(_a, ["safeAreaProps"]);
    const hasSafeArea = useRef(getHasSafeAreaProvider().value).current;
    const hasActionSheet = useRef(getHasActionSheetProvider().value).current;
    const [dir] = useDirection();
    if (!hasSafeArea) {
        if (!hasActionSheet) {
            return (_jsx(ActionSheetProviderView, { children: _jsx(SafeAreaProviderView, Object.assign({}, safeAreaProps, { style: [safeAreaProps === null || safeAreaProps === void 0 ? void 0 : safeAreaProps.style, dir === 'rtl' && { direction: 'rtl' }], children: _jsx(NavigationContent, Object.assign({}, props)) })) }));
        }
        return (_jsx(SafeAreaProviderView, Object.assign({}, safeAreaProps, { children: _jsx(NavigationContent, Object.assign({}, props)) })));
    }
    if (!hasActionSheet) {
        return (_jsx(ActionSheetProviderView, { children: _jsx(NavigationContent, Object.assign({}, props)) }));
    }
    return _jsx(NavigationContent, Object.assign({}, props));
});
const NavigationContent = (_a) => {
    var _b, _c, _d, _e, _f, _g;
    var { style, testID, children, type, theme, enableRoutes, navigation, assets, dynamicStatusBar } = _a, props = __rest(_a, ["style", "testID", "children", "type", "theme", "enableRoutes", "navigation", "assets", "dynamicStatusBar"]);
    const [navigationContainerRef, setNavigationContainerRef] = useNavigationContainerRef();
    const insets = useSafeAreaInsets();
    const color_scheme = useColorScheme();
    useEffect(() => {
        !navigation && updateOffset(insets);
    }, [insets]);
    if (navigation) {
        return _jsx(_Fragment, { children: children });
    }
    if (Platform.OS === 'web' && color_scheme.colors.background_gradient) {
        const currentTheme = Object.assign(Object.assign({}, DefaultTheme), { colors: Object.assign(Object.assign({}, DefaultTheme.colors), { border: ((_b = style === null || style === void 0 ? void 0 : style.container) === null || _b === void 0 ? void 0 : _b.backgroundColor) || '#fff', background: 'transparent' }) });
        return (_jsx(LinearGradient, { colors: color_scheme.colors.background_gradient, locations: color_scheme.colors.background_gradient_locations, style: { flex: 1 }, children: _jsx(NavigationContainer, Object.assign({}, props, { linking: enableRoutes ? linking : undefined, ref: setNavigationContainerRef, theme: theme || currentTheme, children: children })) }));
    }
    if (Platform.OS === 'web' && ((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.screen_background_url)) {
        const currentTheme = Object.assign(Object.assign({}, DefaultTheme), { colors: Object.assign(Object.assign({}, DefaultTheme.colors), { border: ((_d = style === null || style === void 0 ? void 0 : style.container) === null || _d === void 0 ? void 0 : _d.backgroundColor) || '#fff', background: 'transparent' }) });
        return (_jsxs(_Fragment, { children: [_jsx(AnimatedImageView, { image: (_e = assets === null || assets === void 0 ? void 0 : assets.images) === null || _e === void 0 ? void 0 : _e.screen_background_url, containerStyle: { top: 0, bottom: 0, right: 0, left: 0, position: 'absolute' }, resizeMode: 'cover' }), _jsx(NavigationContainer, Object.assign({}, props, { linking: enableRoutes ? linking : undefined, ref: setNavigationContainerRef, theme: theme || currentTheme, children: children }))] }));
    }
    const currentTheme = Object.assign(Object.assign({}, DefaultTheme), { colors: Object.assign(Object.assign({}, DefaultTheme.colors), { border: ((_f = style === null || style === void 0 ? void 0 : style.container) === null || _f === void 0 ? void 0 : _f.backgroundColor) || '#fff', background: color_scheme.colors.background || ((_g = style === null || style === void 0 ? void 0 : style.container) === null || _g === void 0 ? void 0 : _g.backgroundColor) || '#fff' }) });
    return (_jsxs(_Fragment, { children: [_jsx(NavigationContainer, Object.assign({}, props, { linking: enableRoutes ? linking : undefined, ref: setNavigationContainerRef, theme: theme || currentTheme, children: children })), !!dynamicStatusBar && (_jsx(StatusBar, { translucent: true, style: color_scheme.status_bar_color }))] }));
};
